import React from "react";
import { Card } from "antd";
import { KeywordsTable, ChangeSeoDb, AddKeywords } from "../../containers";

const TrackedKeywordsOverview = (props) => {
  return (
    <Card
      className="keywords-data-overview"
      style={{ marginTop: 20 }}
      title={
        <div className="ant-card-meta-detail">
          <div className="ant-card-meta-title">Keywords Overview</div>
          <div className="ant-card-meta-description">{props.domain}</div>
        </div>
      }
      extra={
        <div className="keywords-options card-actions">
          <ChangeSeoDb domain={props.domain} seoDb={props.seoDb} postAction="reload_tracked_keywords" />
          <AddKeywords domain={props.domain} seoDb={props.seoDb} />
        </div>
      }
      data-cy="tracked-keywords-overview">
      <div className="keywords-table">
        <KeywordsTable domain={props.domain} />
      </div>
    </Card>
  );
};

export default TrackedKeywordsOverview;
